<template>
    <footer class="w-full text-center text-gray-600 mt-5 py-5">
        &copy; 2016-2019 Viral News Service. &middot;
        <router-link to="/metrics" class="text-blue-600">
            Metrics
        </router-link>
    </footer>
</template>

<script>
	export default {
		name: 'PageFooter',
	}
</script>
